<template>
  <div>
    <div class="justifiy-content-center">
      <h2>{{ $store.state.customerName }} ページ一覧 Index.vue</h2>
    </div>
    <v-col align="right"><v-btn @click.once="back">戻る</v-btn></v-col>
    <div>
      <v-data-table
        :headers="headers"
        :items="pages"
        :item-key="pages.ID"
        :items-per-page="-1"
        @click:row="move"
      >
        <template v-slot:[`item.page_template_ID`]="{ item }">
          <div>
            <v-icon :color="iconColor(item.page_template_ID)">{{
              icon(item.page_template_ID)
            }}</v-icon>
          </div>
        </template>
        <tr>
          <td>
            <v-text-field
              :v-model="pages"
              type="number"
              label="Less than"
            ></v-text-field>
          </td>
        </tr>
      </v-data-table>

      <v-col align="right">
        <v-btn @click="AllComponentGenerate" color="primary">
          全コンポーネント生成
        </v-btn>
      </v-col>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../api/RepositoryFactory";
const api = RepositoryFactory.get("api2");
export default {
  data: () => ({
    pages: [],
    json: {
      repository: "ide_demo2",
      customerID: 0,
      message: "commit message",
      branch: "localDemo",
    },
  }),
  async mounted() {
    await this.getInit();
  },
  methods: {
    async getInit() {
      //初期処理
      this.isLoading = true;
      this.$store.state.customerID = Number(this.$route.params.id);
      //api通信
      const pages = await api.getPage();
      this.pages = pages;

      //読み込み終了
      this.isLoading = false;
    },
    move(row) {
      let url = "";
      switch (row.page_template_ID) {
        case 1:
          url = "/menu_builder";
          break;
        case 2:
          url = "/report_builder";
          break;
        case 3:
          url = "/index_builder";
          break;
        case 4:
          url = "/MainMenu_builder";
          break;
        case 5:
          url = "/CsvImport_builder";
          break;
        case 6:
          url = "/subreport_builder";
          break;
        case 7: //ユーザ情報設定
          url = "/user_report_builder";
          break;
        case 8: //ユーザ情報一覧
          url = "/user_index_builder";
          break;
        case 9:
          url = "/calenderindex_builder";
          break;
        case 10:
          url = "/graph_builder";
          break;
        case 11:
          alert("グラフ出力の形式はページは未作成");
          return;
        case 12:
          url = "/mail_send_builder";
          break;
        case 13:
          url = "/second_auth_builder";
          break;
        case 15:
          url = "/master_sub";
          break;
        case 16:
          url = "/batch_approval";
          break;
        case 17:
          alert("設定画面は未作成");
          return;
        default:
          alert("登録されていないページタイプです");
          return;
      }

      this.$router.push({
        path:
          "/customer/" + this.$store.state.customerID + "/page/" + row.ID + url,
      });
    },
    icon(value) {
      switch (value) {
        case 1:
          return "mdi-source-branch";
        case 2:
          return "mdi-text-box-plus";
        case 3:
          return "mdi-book-open-blank-variant";
        case 4:
          return "mdi-menu";
        case 5:
          return "mdi-arrow-down-bold-box";
        case 6:
          return "mdi-human-male-child";
        case 7:
          return "mdi-card-account-details";
        case 8:
          return "mdi-text-account";
        case 9:
          return "mdi-book-open";
        case 10:
          return "mdi-calculator";
        case 11:
          return "mdi-chart-bar";
        case 12:
          return "mdi-email-fast-outline";
        case 13:
          return "mdi-check-all";
        case 15:
          return "mdi-chess-queen";
        case 16:
          return "mdi-check-bold";
        default:
          return "mdi-block-helper";
      }
    },
    iconColor(value) {
      switch (value) {
        case 1:
          return "grey darken-2";
        case 2:
          return "orange darken-2";
        case 3:
          return "light-blue lighten-2";
        case 4:
          return "grey darken-2";
        case 5:
          return "deep-purple darken-2";
        case 6:
          return "orange darken-2";
        case 7:
          return "green darken-2";
        case 8:
          return "green darken-2";
        case 9:
          return "light-blue lighten-2";
        case 10:
          return "deep-purple darken-2";
        case 11:
          return "deep-purple darken-2";
        case 12:
          return "deep-purple darken-2";
        case 13:
          return "deep-purple darken-2";
        case 15:
          return "deep-purple darken-2";
        case 16:
          return "deep-purple darken-2";
        default:
          return "red";
      }
    },
    back() {
      this.$router.push({
        path: "/customer/" + this.$store.state.customerID,
      });
    },
    async AllComponentGenerate() {
      try {
        this.isLoading = true;
        this.json.customerID = this.$store.state.customerID;
        const result = await api.AllGenerate(this.json);
        console.log(result.data);
        if (result.data.errors != null) {
          alert("生成失敗\n" + result.data.errors);
        } else {
          alert("生成完了");
        }
      } catch (e) {
        console.log("err", e);
        alert("生成に失敗しました。");
      }
      this.isLoading = false;
    },
  },
  computed: {
    headers() {
      return [
        { text: "アイコン", value: "page_template_ID", width: "7%" },
        {
          text: "ページID",
          value: "ID",
          width: "15%",
          align: "start",
          sortable: true,
        },
        { text: "ページ名", value: "title", width: "30%" },
        { text: "コンポーネント名", value: "component_name" },
      ];
    },
  },
};
</script>

<style lang="stylus"></style>
